import {
  IDeductionRepository,
  IUpdateDeductionIntelligenceRepositoryParams,
  IUpdateDeductionIntelligenceRepositoryResponse,
} from "@/core/repositories/deduction";

export class UpdateDeductionIntelligenceUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IUpdateDeductionIntelligenceRepositoryParams, currentPage: number): Promise<IUpdateDeductionIntelligenceRepositoryResponse> {
    return this.deductionRepository.updateDeductionIntelligence(params, currentPage);
  }
}
